import Vue from 'vue';
import store from './../../store';
import orderTransformer from './../../transformers/order';
import paginationTransformer from '../../transformers/pagination';

const success = ({ data }, resolve) => {
  const orders = orderTransformer.fetchCollection(data.data);
  const pagination = paginationTransformer.fetch(data.pagination);

  store.dispatch('fetchPaginatedOrders', { orders, pagination });
  resolve();
};

const failed = (error, reject) => reject(error);

export default (page = null, limit = null, future, search = null) => (
  new Promise((resolve, reject) => {
    let url = 'orders?filter=appointments';

    if (page && limit) {
      url = `orders?filter=appointments&page=${page}&limit=${limit}`;
    }

    if (future) {
      url += `&future_appointments=${future}`;
    }

    if (search) {
      url += `&search=${search}`;
    }

    return Vue.$http.get(url)
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/appointment/items.js